'use client';
import React from 'react';

interface AldarLogoProps {
  color?: string;
  t?: any;
}

export default function AldarLogo({color = 'currentColor', t}: AldarLogoProps) {
  return (
    <svg
      width='100%'
      height='100%'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 460.844 460.856'
      data-testid='aldar-logo'
      fill={color} // 👈 Now controlled by props!
    >
      <path
        d='M-6880,629.855V170h459.844V629.855Zm4.595-4.607h450.654V174.594h-450.654Zm289.615-73.569-2.35-7.3h-19.017l-2.433,7.3h-18.375l20.577-54.989h19.48l20.506,54.989Zm-13.355-32.126-3.849,11.7h10.774l-3.855-11.7a43.866,43.866,0,0,1-1.577-7.069A54.629,54.629,0,0,1-6599.146,519.553Zm-79.958,32.126V496.691h23.724c19.71,0,28.507,11.384,28.507,27.492s-8.8,27.5-28.507,27.5Zm18.144-15.246h5.1c6.442,0,10.368-3.294,10.368-12.251s-3.926-12.258-10.368-12.258h-5.1Zm-87.192,15.246-2.355-7.3h-19.019l-2.431,7.3h-18.375l20.576-54.989h19.479l20.507,54.989Zm-13.361-32.126-3.851,11.7h10.776l-3.856-11.7a44.4,44.4,0,0,1-1.576-7.069A54.952,54.952,0,0,1-6761.514,519.553Zm35.673,32.124V496.689h18.144v39.117h23.489v15.871Zm196.068-.005-11.313-16.255h-4.246v16.255h-18.151V496.691h25.538c11.7,0,23.4,4.393,23.4,19.4,0,8.563-3.932,13.675-9.429,16.42l14.141,19.166Zm-15.559-29.847h6.991c3.536,0,5.574-2.125,5.574-5.183s-2.038-5.19-5.574-5.19h-6.991Zm-113.191-42.1V393.243a79.443,79.443,0,0,0,9.229.566,77.136,77.136,0,0,0,46.409-15.44V479.726Zm-130.625,0V436.914h14.673c15.665.183,42.9-4.158,42.9-53.6V361.654h19.444a77.622,77.622,0,0,0,35.935,27.338c-1.925,42.807-15.239,72.939-40.323,90.734Zm203.659-.005V434.486h25.855c5.214,0,12.95.136,12.95-8.91,0-21.982-33.314-39.217-33.314-39.217l32.982-32.6c25.325,17.087,35.693,38.3,35.693,38.3v87.671Zm-128.187-161.9c0-29.617,19.042-50.714,19.042-50.714l38.024,21.269c-18.1,22.8-14.288,46.485,6.779,46.485s20.442-19.261,20.442-21.521V243.575h45.033V316.71c0,31.506-25.472,64.506-64.943,64.506C-6684.8,381.216-6713.675,352.4-6713.675,317.825Zm146.649,27.882V243.575h55.7V345.707Z'
        transform='translate(6880.5 -169.499)'
      />
    </svg>
  );
}
